<template>
  <div class="listen">
    <h1 class="structure-header">
      {{ $t('LISTEN.TITLE') }} | MUZIK AIR
    </h1>
    <ListenBanner />
    <ListenWhatHot class="mk-container" />
    <div class="mk-containers pgnnp-containers">
      <Paganiniplus />
    </div>
    <ListenScenarioList
      class="mk-container"
      :title="'SCENARIO.GREATEST_HITS'"
      :text-position="'outside'"
      :assigned-id-ary="scenarioList1"
    />
    <div class="mk-containers pgnnp-containers">
      <Paganiniplus />
    </div>
    <ListenScenarioSlider class="mk-container" />
    <ListenScenarioActivity class="mk-container" />
    <div class="mk-containers pgnnp-containers">
      <Paganiniplus />
    </div>
    <ListenScenarioList
      class="mk-container"
      :title="'SCENARIO.PERIODS'"
      :text-position="'inside'"
      :assigned-id-ary="scenarioList2"
      :placeholder-num="16"
    />
    <div class="mk-containers pgnnp-footer">
      <Paganiniplus />
    </div>
  </div>
</template>

<script>

import Paganiniplus from '@/components/tsp/Paganiniplus'
import ListenBanner from '@/components/listen/ListenBanner'
import ListenWhatHot from '@/components/listen/ListenWhatHot'
import ListenScenarioList from '@/components/listen/ListenScenarioList'
import ListenScenarioActivity from '@/components/listen/ListenScenarioActivity'
import ListenScenarioSlider from '@/components/listen/ListenScenarioSlider'

export default {
  name: 'Listen',
  components: {
    Paganiniplus,
    ListenBanner,
    ListenWhatHot,
    ListenScenarioList,
    ListenScenarioActivity,
    ListenScenarioSlider
  },
  props: {},
  data() {
    return {
      scenarioList1: [
        // '8f72ff39-d141-4dcd-a96b-ddb7fef333f2', // 2020 蕭邦⼤賽
        '9129a59a-3487-48d6-8ae9-0d4ad5fae61b', // Podcast
        '8f730379-f309-4d9c-ad92-726fdbef70a5', // 樂團甄試⼤全
        '8f730656-22b7-4639-807c-53d1cf7cd87b', // 演奏形式
        '8bab9370-864f-48f8-81bf-db3decb14028', // TOP 100
        '8bab9353-8e2e-4807-8797-642627d90e73', // 舒壓
        '8bab932c-d298-4361-8d2d-abbf44358b06', // 閱讀
        '8bab933a-a935-4548-8ee5-421f9220d4d5', // ⼯作
        '8bab9365-c74d-435e-83c6-31d26f4af7da' // 睡眠
      ],
      scenarioList2: [
        '8bab933e-698a-4787-80eb-85a0c22e7751', // TOP 100 單曲
        '8bab9348-bdc5-42b1-a75e-0fc304d80952', // ⽂藝復興時期
        '8bab9380-1521-4805-865a-0b6e51ad8730', // 巴洛克時期
        '8bab937d-ade6-4344-8539-c1e07f9701b5', // 古典時期
        '8bab9372-0c7d-460f-8aae-46f218ab9677', // 浪漫時期
        '8f731eca-ec55-43c6-b472-73ad6777b09d', // 象徵主義及印象樂派
        '8bab9387-7a8f-4392-9f42-d6ae325d0b3f', // 近代⾳樂
        '8bab932a-7753-42a4-968b-cef66094de95' // 台灣⾳樂
      ]
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      return `${this.$t('LISTEN.TITLE')} | MUZIK AIR`
    },
    description() {
      return this.$t('LISTEN.META_DESCRIPTION')
    },
    keywords() {
      return this.$t('LISTEN.META_KEYWORDS')
    },
    cover() {
      return `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/listen.png`
    },
    canonicalURL() {
      return `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    structuredData() {
      return [{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.description,
        author: {
          '@type': 'Organization',
          sameAs: [
            'https://facebook.com/muzikcom/',
            'https://www.instagram.com/muzikmagazine/',
            'http://line.me/ti/p/@pwr7122w#~',
            'https://www.youtube.com/user/MUZIKmagazine'
          ]
        },
        publisher: {
          '@type': 'Organization',
          sameAs: [
            'https://facebook.com/muzikcom/',
            'https://www.instagram.com/muzikmagazine/',
            'http://line.me/ti/p/@pwr7122w#~',
            'https://www.youtube.com/user/MUZIKmagazine'
          ]
        },
        relatedLink: [
          `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_AIR}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      },
      {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        url: `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}`,
        logo: {
          '@type': 'ImageObject',
          'url': this.cover
        }
      }]
    }
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
  // .mk-container{
  //   max-width: 100% !important;
  //   padding: 0 !important;
  // }
  .structure-header {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    visibility: hidden;
  }
  .pgnnp-containers {
    // margin: 36px 0;
    // margin-top: 0px;
  }
  .pgnnp-footer {
    margin-bottom: 36px;
  }
</style>
